// import React, { useState, useEffect } from 'react';
// import { Search, Trash2 } from 'lucide-react';
// import './arrondissement.css';

// const API_BASE_URL = 'https://api.wemaza.com/api/demandes/etapes';

// const DemandesEtapes = () => {
//   const [demandes, setDemandes] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [searchTerm, setSearchTerm] = useState('');

//   useEffect(() => {
//     fetchDemandesEtapes();
//   }, []);

//   const fetchDemandesEtapes = async () => {
//     try {
//       setLoading(true);
//       const response = await AxiosInstance.get(API_BASE_URL);
//       if (!response.ok) throw new Error('Erreur lors du chargement des demandes d\'étapes');
//       const data = await response.json();
//       setDemandes(data);
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleStatutChange = async (id, newStatut) => {
//     try {
//       const response = await AxiosInstance.delete(`${API_BASE_URL}/${id}`);
//         method: 'PATCH',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ statut: newStatut }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || 'Erreur lors de la mise à jour');
//       }

//       await fetchDemandesEtapes();
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm('Êtes-vous sûr de vouloir supprimer cette demande d\'étape ?')) return;
//     try {
//       const response = await AxiosInstance.delete(`${API_BASE_URL}/${id}`);
//         
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || 'Erreur lors de la suppression');
//       }

//       await fetchDemandesEtapes();
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   const getStatutColor = (statut) => {
//     switch (statut) {
//       case 'NON_TRAITE':
//         return 'bg-red-200';
//       case 'EN_COURS':
//         return 'bg-yellow-200';
//       case 'TRAITE':
//         return 'bg-green-200';
//       default:
//         return 'bg-gray-200';
//     }
//   };

//   const filteredDemandes = demandes.filter(demande =>
//     demande.nomDemarche.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     (demande.description && demande.description.toLowerCase().includes(searchTerm.toLowerCase()))
//   );

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="loading-spinner"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="arrondissement-container">
//       <div className="container mx-auto px-4 py-4">
//         <div className="card page-header">
//           <div className="header-content">
//             <div className="header-title-section">
//               <div>
//                 <h1 className="header-title">Gestion des Demandes d'Étapes</h1>
//                 <p className="header-subtitle">Gérer les demandes d'étapes</p>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="card filters-section">
//           <div className="search-container">
//             <Search className="search-icon" />
//             <input
//               type="text"
//               placeholder="Rechercher une demande..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="search-input"
//             />
//           </div>
//         </div>

//         {error && (
//           <div className="error-message">
//             {error}
//           </div>
//         )}

//         <div className="table-container">
//           <div className="table-scroll">
//             <table className="data-table">
//               <thead className="table-header">
//                 <tr>
//                   <th>Nom de la démarche</th>
//                   <th>Description</th>
//                   <th>Statut</th>
//                   <th>Utilisateur</th>
//                   <th>Procédure</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody className="table-body">
//                 {filteredDemandes.length === 0 ? (
//                   <tr>
//                     <td colSpan="6" className="empty-state">
//                       <p className="empty-title">Aucune demande trouvée</p>
//                       <p className="empty-subtitle">Essayez de modifier vos critères de recherche</p>
//                     </td>
//                   </tr>
//                 ) : (
//                   filteredDemandes.map((demande) => (
//                     <tr key={demande._id} className="table-row">
//                       <td className="table-cell">
//                         <div className="cell-title">{demande.nomDemarche}</div>
//                       </td>
//                       <td className="table-cell">
//                         <div className="cell-description">{demande.description || 'Aucune description'}</div>
//                       </td>
//                       <td className="table-cell">
//                         <div className={`cell-statut ${getStatutColor(demande.statut)}`}>
//                           {demande.statut}
//                         </div>
//                       </td>
//                       <td className="table-cell">
//                         <div className="cell-user">
//                           {demande.utilisateurId ? `${demande.utilisateurId.nom} (${demande.utilisateurId.email})` : 'N/A'}
//                         </div>
//                       </td>
//                       <td className="table-cell">
//                         <div className="cell-procedure">
//                           {demande.procedureId ? demande.procedureId.nom : 'N/A'}
//                         </div>
//                       </td>
//                       <td className="table-cell">
//                         <div className="actions-container">
//                           <select
//                             value={demande.statut}
//                             onChange={(e) => handleStatutChange(demande._id, e.target.value)}
//                             className="statut-select"
//                           >
//                             <option value="NON_TRAITE">Non Traitée</option>
//                             <option value="EN_COURS">En Cours</option>
//                             <option value="TRAITE">Traitée</option>
//                           </select>
//                           <button
//                             onClick={() => handleDelete(demande._id)}
//                             className="action-button delete"
//                             title="Supprimer"
//                           >
//                             <Trash2 className="action-icon" />
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         <div className="card stats-section">
//           <div className="stats-grid">
//             <div className="stat-item">
//               <div className="stat-number blue">{demandes.length}</div>
//               <div className="stat-label">Total Demandes</div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DemandesEtapes;


import React, { useState, useEffect } from 'react';
import { Search, Trash2 } from 'lucide-react';
import './arrondissement.css';
import AxiosInstance from "../AxiosInstance";

const API_BASE_URL = '/api/demandes/etapes';

const DemandesEtapes = () => {
  const [demandes, setDemandes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchDemandesEtapes();
  }, []);

  const fetchDemandesEtapes = async () => {
    try {
      setLoading(true);
      const response = await AxiosInstance.get(API_BASE_URL);
      setDemandes(response.data);
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Erreur lors du chargement des demandes d\'étapes');
    } finally {
      setLoading(false);
    }
  };

  const handleStatutChange = async (id, newStatut) => {
    try {
      await AxiosInstance.patch(`${API_BASE_URL}/${id}`, { statut: newStatut });
      await fetchDemandesEtapes();
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Erreur lors de la mise à jour');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer cette demande d\'étape ?')) return;

    try {
      await AxiosInstance.delete(`${API_BASE_URL}/${id}`);
      await fetchDemandesEtapes();
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Erreur lors de la suppression');
    }
  };

  const getStatutColor = (statut) => {
    switch (statut) {
      case 'NON_TRAITE':
        return 'bg-red-200';
      case 'EN_COURS':
        return 'bg-yellow-200';
      case 'TRAITE':
        return 'bg-green-200';
      default:
        return 'bg-gray-200';
    }
  };

  const filteredDemandes = demandes.filter((demande) =>
    demande.nomDemarche.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (demande.description && demande.description.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="arrondissement-container">
      <div className="container mx-auto px-4 py-4">

        {/* Header */}
        <div className="card page-header">
          <div className="header-content">
            <div className="header-title-section">
              <h1 className="header-title">Gestion des Demandes d'Étapes</h1>
              <p className="header-subtitle">Gérer les demandes d'étapes</p>
            </div>
          </div>
        </div>

        {/* Search Filter */}
        <div className="card filters-section">
          <div className="search-container">
            <Search className="search-icon" />
            <input
              type="text"
              placeholder="Rechercher une demande..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>
        </div>

        {/* Error Message */}
        {error && <div className="error-message">{error}</div>}

        {/* Table */}
        <div className="table-container">
          <div className="table-scroll">
            <table className="data-table">
              <thead className="table-header">
                <tr>
                  <th>Nom de la démarche</th>
                  <th>Description</th>
                  <th>Statut</th>
                  <th>Utilisateur</th>
                  <th>Procédure</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody className="table-body">
                {filteredDemandes.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="empty-state">
                      <p className="empty-title">Aucune demande trouvée</p>
                      <p className="empty-subtitle">Essayez de modifier vos critères de recherche</p>
                    </td>
                  </tr>
                ) : (
                  filteredDemandes.map((demande) => (
                    <tr key={demande._id} className="table-row">
                      <td className="table-cell">{demande.nomDemarche}</td>
                      <td className="table-cell">{demande.description || 'Aucune description'}</td>
                      <td className="table-cell">
                        <div className={`cell-statut ${getStatutColor(demande.statut)}`}>
                          {demande.statut}
                        </div>
                      </td>
                      <td className="table-cell">
                        {demande.utilisateurId
                          ? `${demande.utilisateurId.name} (${demande.utilisateurId.email})`
                          : 'N/A'}
                      </td>
                      <td className="table-cell">
                        {demande.procedureId
                          ? demande.procedureId.titre
                          : 'N/A'}
                      </td>
                      <td className="table-cell">
                        <div className="actions-container">
                          <select
                            value={demande.statut}
                            onChange={(e) => handleStatutChange(demande._id, e.target.value)}
                            className="statut-select"
                          >
                            <option value="NON_TRAITE">Non Traitée</option>
                            <option value="EN_COURS">En Cours</option>
                            <option value="TRAITE">Traitée</option>
                          </select>
                          <button
                            onClick={() => handleDelete(demande._id)}
                            className="action-button delete"
                            title="Supprimer"
                          >
                            <Trash2 className="action-icon" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Statistiques */}
        <div className="card stats-section">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number blue">{demandes.length}</div>
              <div className="stat-label">Total Demandes</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemandesEtapes;
